import {Client, RemoteClient} from 'common/src/modules/clients/clients.types';
import {
  SUSPEND_DAYS_DEFAULT,
  defaultAnalyticsSettings,
  defaultServiceSettings,
} from './clients.config';

export function accountProfileToClientModel(client: RemoteClient): Client {
  return {
    ...client,
    id: client.clientId,
    servicesSettings: client.servicesSettings || defaultServiceSettings,
    analyticsSettings: client.analyticsSettings || defaultAnalyticsSettings,
    securitySettings: {
      ...client.securitySettings,
      daysForInactivityBeforeSuspension:
        client.securitySettings.daysForInactivityBeforeSuspension || SUSPEND_DAYS_DEFAULT,
    },
    allSupportedProducts: [
      ...client.defaultProductTypes,
      ...(client.additionalProductTypes ? client.additionalProductTypes : []),
    ],
  };
}
